module.exports = __webpack_public_path__ + "static/loadingGif-a1dd5b0f6714676a72355eaf099abdc6.gif";